import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastNotificationService } from '../../app/core/others/toast-notification/toast-notification.service';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { DataService } from '../../app/modules/pages/create-new-submission/service/data.service';
import { LoadingComponent } from "../loading/loading.component";
import { of } from 'rxjs';

@Component({
  selector: 'app-profile-settings',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, LoadingComponent],
  templateUrl: './profile-settings.component.html',
  styleUrl: './profile-settings.component.scss'
})
export class ProfileSettingsComponent implements OnInit {
  @Input() email = '';
  @Input() fullName = '';
  @Input() role = '';
  @Input() isAgent = false;

  form!: FormGroup;
  isLoading = false;

  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private toastr: ToastNotificationService,
    private dataService: DataService
  ) { }

  ngOnInit(): void {
    if (!this.isAgent) {
      this.isAgent = this.role?.toLowerCase().replace(/\s/g, '_') === 'agent';
    }
    this.form = this.fb.group({
      email: [{ value: this.email, disabled: true }, [Validators.required, Validators.email]],
      fullName: [this.fullName, Validators.required],
      role: [{ value: this.formatRole(this.role), disabled: true }],
      agencyName: [{ value: '', disabled: true }],
      agencyNpn: [{ value: '', disabled: true }],
      principalName: [{ value: '', disabled: true }]
    });
    if (this.isAgent && this.email) {
      this.fetchAgentSummary();
    }
  }

  private sanitize(value: unknown): string {
    if (value === null || value === undefined) return 'No Principal Assigned';
    const str = String(value);
    return str === 'null' || str === 'undefined' || str === 'NaN' || str.trim() === '' ? 'No Principal Assigned' : str;
  }


  private fetchAgentSummary(): void {
    this.isLoading = true;
    this.dataService.getAgentSummary(this.email).subscribe({
      next: (res) => {
        if (res?.success && res?.data) {
          const { agent_name, agency_name, agency_npn, principal_agent } = res.data;
          this.form.patchValue({
            fullName: agent_name || this.fullName,
            agencyName: agency_name || '',
            agencyNpn: agency_npn || '',
            principalName: this.sanitize(principal_agent) || ''
          });
        }
        this.isLoading = false;
      },
      error: (err) => {
        this.isLoading = false;
        this.toastr.showError('Failed to fetch agent details');
      }
    });
  }


  private formatRole(role: string): string {
    const normalized = (role ?? '').toLowerCase().replace(/_/g, ' ').trim();
    if (!normalized) return '';

    if (normalized === 'uw assistant' || normalized === 'uw_assistant' || normalized === 'uw assist' || normalized === 'uw_assist') {
      return 'Underwriting Assistant';
    }

    
    if (normalized === 'underwriter') {
      return 'Underwriter';
    }

    return normalized.replace(/\b\w/g, c => c.toUpperCase());
  }

  save(): void {
    if (this.form.invalid) return;

    const { email, fullName } = this.form.getRawValue();
    this.toastr.showSuccess('Profile details saved successfully');
    this.activeModal.close({ email, fullName });
  }
}
